import { defineStore } from 'pinia'
// import { ref } from 'vue'

export const useSnackbarStore = defineStore('snackbar', () => {
  const isVisible = ref(false) // Snackbar visibility
  const message = ref('') // Snackbar message
  const color = ref('red') // Snackbar color
  const timeout = ref(3000) // Snackbar timeout
  const position = ref('top right')

  // Function to show the snackbar
  const showSnackbar = (
    msg = '',
    snackbarColor = 'red',
    snackbarTimeout = 3000,
    pos = 'top right',
  ) => {
    message.value = msg
    color.value = snackbarColor
    timeout.value = snackbarTimeout
    position.value = pos
    isVisible.value = true
  }

  // Function to close the snackbar
  const closeSnackbar = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    message,
    color,
    timeout,
    position,
    showSnackbar,
    closeSnackbar,
  }
})
export default useSnackbarStore
